<div class="input-group">
	<button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
		{{ search?.label ?? 'Buscar por' }}
	</button>
	<ul class="dropdown-menu">
		@for (search of listSearch; track search) {
			<li>
				<a class="dropdown-item" (click)="setTypeSearch(search)">{{ search?.label }}</a>
			</li>
		}
	</ul>
	<input (keyup.enter)="submitSearch()" [formControl]="searchTerm" id="search" class="form-control" />
	<a (click)="submitSearch()" class="magnifier">
		<img alt="search" src="/assets/icons/svg/magnifier-icon.svg" loading="lazy" />
	</a>
</div>
